import { render, staticRenderFns } from "./ConsultantBox.vue?vue&type=template&id=5abac70f"
import script from "./ConsultantBox.vue?vue&type=script&lang=js"
export * from "./ConsultantBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports